<!--  -->
<template>
  <div>
    <div class="select">
      <div class="selectcenter">
        <img src="../../assets/img/logo (1).png" alt="" />
        <input type="text" placeholder="全文智能搜索" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>

.select {
  display: flex;
  width: 100%;
  height: 180px;
  border-top: 3px solid #2da2d8; /* 这里是新添加的样式 */
  /* background-color: red; */
  justify-content: center; /* 水平居中 */
}
.selectcenter {
  width: 55%;
  /* background-color: gray; */
  display: flex;
  align-items: center; /* 垂直居中 */
}
.selectcenter img {
  margin-right: 10px;
}
.select input[type="text"] {
  flex: 1;
  height: 36px;
  border: none;
  outline: none;
  font-size: 16px;
  padding: 0 10px;
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  background-image: linear-gradient(to bottom, #f6f6f6, #fff);
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue